import absoluteDiscountAmount from './absoluteDiscountAmount.js'
import effectiveDiscount from './effectiveDiscount.js'
import LocalDate from '@booking-services/localDate'
import max from 'lowscore/max.js'
import sum from 'root-core/utils/array/sum.js'
import {applicableSupplementSelector} from './applicableSupplementReduction.js'

export function bestAvailableEPD (epds, passengers, bookingDate, departure) {
  var discountAmounts = availableEPDs({epds, bookingDate}).map(discount => {
    const amountPerPassenger = passengers.map(passenger => {
      const {discountReduction} = applicableSupplementSelector({supplementAdjustments: departure.prices.roomSupplementAdjustments, roomType: passenger.roomType, bookingDate})
      const roomPrice = discountReduction
        ? passenger.basicRoomPrice - passenger.applicableRoomTypeSupplement
        : passenger.basicRoomPrice
      return {
        amount: absoluteDiscountAmount(roomPrice, discount, 1),
        passengerId: passenger.passengerId,
      }
    })

    return {
      id: discount.id,
      code: 'EPD',
      name: discount.name,
      automatic: false,
      paymentBy: {
        date: paymentBy(discount, departure),
      },
      amount: sum(amountPerPassenger.map(a => a.amount)),
      discountType: discount.discountType,
      fixedAmount: discount.fixedAmount,
      percent: discount.percent,
      amountPerPassenger,
      earlyBirdDepartureDaysId: discount.earlyBirdDepartureDaysId,
      products: [{productCode: departure.productCode}],
      combinable: true,
      epdCombinable: true,
      epd: true,
      combinabilityGroups: [],
      bookingDateWindow: discount.bookingDateWindow,
      type: 'earlyPayment',
    }
  })

  if (discountAmounts.length) {
    return max(discountAmounts, d => d.amount)
  }
}

/**
 * Get date regarding limit for payment of an EPD
 *
 * @param {Object} epd
 * @param {Object} departure
 *
 * @return {Object} date limit of payment
 */
function paymentBy (epd, departure) {
  return epd.paymentDate || departure.startDate
}

/**
 * Check if a specific departure is excluded from the EPD because of the payment date.
 * This could happen because the epd has a exclude days number that will postpone the payment date
 * disabling some departures for that EPD
 *
 * @param {Object} epd
 * @param {Object} departureDate
 *
 * @return {boolean} is the departure excluded
 */
function departureNotExcluded (epd, departureDate) {
  const travelDate = departureDate ? new LocalDate(departureDate) : departureDate
  if (travelDate) {
    return travelDate > epd.paymentDate
  } else {
    return true
  }
}

/**
 * Filter available EPDs for a given travel date and booking date
 *
 * @param {array} epds
 * @param {LocalDate} bookingDate
 * @param {LocalDate} travelDate
 *
 * @return {array} epds applicable in the above conditions
 */
export function availableEPDs ({epds = [], bookingDate, travelDate}) {
  return epds.filter(discount => {
    return effectiveDiscount({discount, bookingDate})
      && bookingDate < discount.paymentDate.addDays(1)
      && departureNotExcluded(discount, travelDate)
  })
}
